export default __webpack_public_path__ + "static/media/popup_deco_line.849be7b1.svg";